import client from './client';

export const aiCoachApi = {
  sendMessage: (data) => client.post('/ai-coach', data),
  getHistory: (clientId) =>
    client.get('/ai-coach/history', { params: { client_id: clientId } }),

  // Admin
  getTips: () => client.get('/ai-coach/tips'),
  createTip: (data) => client.post('/ai-coach/tips', data),
  updateTip: (id, data) => client.put(`/ai-coach/tips/${id}`, data),
  deleteTip: (id) => client.delete(`/ai-coach/tips/${id}`),
  toggleTip: (id) => client.put(`/ai-coach/tips/${id}/toggle`),
  getClients: () => client.get('/ai-coach/clients'),
  getSettings: () => client.get('/ai-coach/settings'),
  getProviders: () => client.get('/ai-coach/providers'),
  testApiKey: (data) => client.post('/ai-coach/settings/test-key', data),
  saveApiKey: (data) => client.put('/ai-coach/settings/api-key', data),
};
